var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBills(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.99,
    height: 19.991,
    viewBox: "0 0 19.99 19.991",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_7cb83252540d783cc7e0556c82b5a3fd",
    "data-name": "7cb83252540d783cc7e0556c82b5a3fd",
    transform: "translate(-3 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20647",
    "data-name": "Path 20647",
    d: "M32.76,34.952H28.476a.476.476,0,0,1,0-.952H32.76a.476.476,0,1,1,0,.952Z",
    transform: "translate(-13.101 -16.245)",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20648",
    "data-name": "Path 20648",
    d: "M14.187,23.952H8.476a.476.476,0,0,1,0-.952h5.711a.476.476,0,0,1,0,.952Zm0,2.38H8.476a.476.476,0,0,1,0-.952h5.711a.476.476,0,0,1,0,.952Zm0,2.38H8.476a.476.476,0,0,1,0-.952h5.711a.476.476,0,0,1,0,.952Z",
    transform: "translate(-2.62 -10.481)",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20649",
    "data-name": "Path 20649",
    d: "M29.567,18.707a2.859,2.859,0,0,1-2.856-2.856V10.615a1.428,1.428,0,0,0-1.428-1.428H21.476A.476.476,0,0,1,21,8.711V3.476A.476.476,0,0,1,21.476,3a1.7,1.7,0,0,1,1.177.465.781.781,0,0,0,1.145,0,1.713,1.713,0,0,1,2.344,0,.781.781,0,0,0,1.142,0,1.713,1.713,0,0,1,2.345,0,.781.781,0,0,0,1.142,0A1.691,1.691,0,0,1,31.947,3a.476.476,0,0,1,.476.476V15.851a2.859,2.859,0,0,1-2.856,2.856ZM21.952,8.235h3.332a2.383,2.383,0,0,1,2.38,2.38v5.236a1.9,1.9,0,1,0,3.808,0V4.126l-.1.075a1.717,1.717,0,0,1-2.35,0,.775.775,0,0,0-1.138,0,1.717,1.717,0,0,1-2.35,0,.775.775,0,0,0-1.138,0,1.718,1.718,0,0,1-2.349,0c-.036-.029-.068-.056-.1-.079Z",
    transform: "translate(-9.433)",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20650",
    "data-name": "Path 20650",
    d: "M13.947,28.755a1.626,1.626,0,0,1-1.2-.532c-.208-.19-.31-.277-.55-.277s-.342.085-.55.278a1.613,1.613,0,0,1-2.393,0c-.208-.19-.309-.277-.548-.277s-.341.085-.548.277a1.611,1.611,0,0,1-2.392,0c-.207-.19-.309-.277-.548-.277s-.341.085-.548.277a1.623,1.623,0,0,1-1.2.531A.476.476,0,0,1,3,28.279V17.332A3.336,3.336,0,0,1,6.332,14h9.519a.476.476,0,1,1,0,.952,1.428,1.428,0,0,0-1.428,1.428v11.9A.476.476,0,0,1,13.947,28.755ZM8.708,26.994a1.622,1.622,0,0,1,1.2.532c.208.19.309.277.549.277s.342-.085.55-.277a1.614,1.614,0,0,1,2.395,0l.074.068V16.38a2.367,2.367,0,0,1,.476-1.428H6.332a2.383,2.383,0,0,0-2.38,2.38v10.26c.023-.021.048-.043.072-.067a1.611,1.611,0,0,1,2.392,0c.207.19.309.277.548.277s.341-.085.548-.277a1.622,1.622,0,0,1,1.2-.532Z",
    transform: "translate(0 -5.765)",
    fill: "#363636"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBills);
export default __webpack_public_path__ + "static/media/Bills.48c754f8da5d89aa3a0b2342e49fe81d.svg";
export { ForwardRef as ReactComponent };